export const formSubmissionMixin = {
    data() {
        return {
            form_valid: true,
            token2: '88204aeaa32820f65815d91f0bd8bb803514079dfadd5cd1f97e55c97caf7f76',
            endpoint: 'https://belomedical.zendesk.com/api/v2/requests.json',
            authorization: 'I0yYcLaduRTn7hKOLuTUwhdrSDpHf2oQC4ru1M9D',
            description: '',
            subject: '',
            submitting: false,
            sent: false,
            temp_form_id: '',
            modal_timer: 10,
            internal_endpoint: '',
            captchaToken: '',
            error: false,
            error_msg: ''
        }
    },

    methods: {

        showSuccessModal() {
            const modalSuccess = new bootstrap.Modal(document.getElementById('modalSuccessForm'), {
                keyboard: false
            });

            modalSuccess.show();

            const modalTimer = setInterval(() => {
                this.modal_timer = this.modal_timer - 1;

                if (this.modal_timer == 0) {
                    window.location.href = '/'
                    clearInterval(modalTimer);
                }
            }, 1000);



        },

        submitForm(event, formId) {
            this.temp_form_id = formId;
            this.error = false;
            this.error_msg = '';

            if (this.isValid) {
                this.createTicket();
            }
        },

        createTicket() {
            let self = this;
            this.submitting = true;

            let fields = this.local_fields[this.temp_form_id];

            let email = fields['4411547373967'] ? fields['4411547373967']['data'] : 'info@belomed.com';
            let name = fields['4414170521231'] ? fields['4414170521231']['data'] : 'Belo client';

            axios.post(document.getElementById('formPost').value, {
                request: {
                    custom_fields: self.params,
                    requester: {
                        name: name,
                        email: email
                    },
                    subject: fields['360023130396']['data'],
                    comment: {
                        body: self.description
                    },
                    priority: 'urgent',
                    ticket_form_id: self.temp_form_id
                },
                'g-recaptcha-response': document.getElementById('recaptchaResponse').value
            },
                {
                    headers: {
                        'Authorization': `Basic Hi17BIskFkit92IGlp55nFvkAkbO3FcqB262GSZD`,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(response => {
                    this.submitting = false;
                    this.sent = true;

                    this.temp_form_id = '';

                    this.showSuccessModal();


                }).catch(error => {
                    this.submitting = false;

                    this.error = true;
                    if (error['response']['data']) {
                        this.error_msg = error['response']['data']['message'] ? error.response.data.message : '';
                    }
                });

        },

        setValue(value, field) {
            this[field] = value;
        }
    },

    computed: {

        params() {
            let params = [];
            let formFieldKeys = Object.keys(this.local_fields[this.temp_form_id]);


            formFieldKeys.forEach(key => {
                let item = this.local_fields[this.temp_form_id][key];

                let type = item.type;

                type == 'description' && this.setValue(item.data, item.type)


                params.push({
                    id: item.id,
                    value: typeof item.data == 'string' ? item.data : item.data.map(item => item.value),
                });


            });


            return params;
        },

        isValid() {
            let valid = true;
            console.log(this.local_fields);
            let activeForm = this.local_fields[this.temp_form_id];
            let fieldKeys = Object.keys(activeForm);


            fieldKeys.forEach(fieldKey => {
                let item = activeForm[fieldKey];
                if (item.required_in_portal) {

                    if (item.type == 'subject' && !item.data) {
                        this.local_fields[this.temp_form_id][fieldKey].data = this.$refs.subject[0].value;
                    }

                    let itemType = typeof item.data;
                    if (itemType == 'array' && !item.data.length) {
                        item.has_error = true;
                        valid = false;
                    }

                    if (itemType == 'string' && !item.data) {
                        item.has_error = true;

                        valid = false;
                    }
                }
            })

            return valid;
        }
    }
}